import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PageContentWrapper from "../../components/PageContentWrapper";
import { getTrainingVideo } from "../../appRedux/actions/TrainingVideo";
import { Collapse } from "antd";
import moment from "moment";

export default function DetailMyRecordedPage() {
  const { trainingId } = useParams()
  const [videos, setVideos] = useState([])

  useEffect(() => {
    getTrainingVideo(trainingId).then(data => setVideos(data))
  }, [])

  return <PageContentWrapper
    title="Lihat Rekaman Kelas"
    backLink={"/my-recorded"}
  >
    <Collapse defaultActiveKey={['0']}>
      {videos && videos.map((video, index) => (
        <Collapse.Panel
          header={moment(video.training_date.date, "YYYY-MM-DDT").format("dddd, D MMMM YYYY") + " : " + video.name}
          key={index}>
          <div dangerouslySetInnerHTML={{ __html: video.code }}></div>
        </Collapse.Panel>
      ))}
    </Collapse>
  </PageContentWrapper>
}